var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPointItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 4,
  fill: "#E6E9EC"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 5a5.257 5.257 0 0 0-5.25 5.25c0 3.77 4.891 8.49 5.1 8.689a.217.217 0 0 0 .3 0c.209-.2 5.1-4.92 5.1-8.689A5.257 5.257 0 0 0 12 5Zm0 7.656a2.406 2.406 0 1 1 0-4.812 2.406 2.406 0 0 1 0 4.812Z",
  fill: "#343A3F"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(5 5)",
  d: "M0 0h14v14H0z"
})))));
export default SvgPointItem;